import {EnvironmentTypes} from '../app/Enums/environment-types';

export const environment = {
    tenant: EnvironmentTypes.MSS,
    production: true,
    redirectUri: 'https://arp-ss-app-stage.azureedge.net/',
    postLogoutRedirectUri: 'https://arp-ss-app-stage.azureedge.net/',
     arpApiUrl: 'https://arp-ss-api-stage.azurewebsites.net',
    portalUrl: 'https://arp-portal-stage.azureedge.net/?autoredirect=false',
    msalAuthority: 'https://login.microsoftonline.com/a76381c7-ea6e-41f4-8bb8-cb6ec292a8a0',
    msalClientId: '67584d50-2f4b-4d92-af27-fb4041b8f41c',
    authScopes: [
        {
            apiUrl: 'https://arp-ss-api-stage.azurewebsites.net/v2_0',
            scope: 'api://94c9dd15-091e-4043-863d-184f393e6dc4/Api.ReadWrite.All'
        }
    ]
};
